module.exports = __webpack_public_path__ + "dojo-development.1JylvAGv.svg";